import AbstractLazyLoad from '../../../commons/js/components/lazy-load/AbstractLazyLoad';

export default function () {
	new HowItWorksCarouselLoader().initialize();
}

class HowItWorksCarouselLoader extends AbstractLazyLoad {
	glide: any;

	constructor() {
		super('.l-how-it-works__glide');

		this.glide = null;
	}

	protected load(): void {
		window.addEventListener('resize', () => {
			if (window?.innerWidth < 1024) {
				if (!this.glide) {
					this.createSlider();
				}
			} else {
				if (this.glide) {
					this.glide.destroy();
					this.glide = null;
				}
			}
		});

		if (window?.innerWidth < 1024) {
			this.createSlider();
		}
	}

	private createSlider() {
		import('@glidejs/glide').then(({ default: Glide }) => {
			const params = {
				type: 'carousel',
				perView: 1,
				focusAt: 'center',
			};

			this.glide = new Glide('.glide', params).mount();
		});
	}
}